import ConceptFixedButton from './ConceptFixedButton'

export default ConceptFixedButton;